// extracted by mini-css-extract-plugin
module.exports = {"progressBarContainer":"ExamProgressBar_progressBarContainer__22Sb7","progressBar":"ExamProgressBar_progressBar__7Fmhs","isExamPassed":"ExamProgressBar_isExamPassed__zeFfP"};